import moment from 'moment';

export const getTimeDiff = (endTime: string) => {
  let diff = moment.duration(moment().diff(endTime));
  let diffHours = Number(diff.asHours().toFixed(0));
  let diffDays = Number(diff.asDays().toFixed(0));
  let diffMinutes = Number(diff.asMinutes().toFixed(0));
  let diffSeconds = Number(diff.asSeconds().toFixed(0));

  if (diffSeconds < 60) {
    return `Less than a minute ago`;
  } else if (diffMinutes < 60) {
    return `About ${diffMinutes === 1 ? 'a' : diffMinutes} minute${diffMinutes > 1 ? 's' : ''} ago`;
  } else if (diffHours < 24) {
    return `About ${diffHours === 1 ? 'an' : diffHours} hour${diffHours > 1 ? 's' : ''}  ago`;
  } else {
    return `About ${diffDays === 1 ? 'a' : diffDays} day${diffDays > 1 ? 's' : ''}  ago`;
  }
};
